/**
 * 서비스워커 해제 상한. 이 시간 안에 못 끝내면 해제를 포기하고 그대로 진행한다.
 *
 * 정상 해제는 수백 ms 안에 끝나므로, `SERVICE_WORKER_READY_TIMEOUT_MS` 와 같은 기준으로 잡은
 * 값이다 — 정상 해제를 놓치지 않을 만큼 넉넉하되, 새로고침 클릭이 멈춘 것처럼 보이지 않을
 * 만큼 짧게. 상수를 따로 두는 것은 그쪽 이름이 `ready` 를 가리켜서다.
 */
export const SERVICE_WORKER_UNREGISTER_TIMEOUT_MS = 3_000;

/**
 * 등록된 서비스워커를 상한 안에서 전부 해제한다. 못 끝내도 거부하지 않고 그냥 끝난다.
 *
 * `getRegistrations()` 와 `unregister()` 는 `navigator.serviceWorker.ready` 와 같은 계통이라
 * (`serviceWorkerReady.ts` 참조) 거부도 타임아웃도 없이 대기만 하는 상태가 있다 — iOS 가
 * 백그라운드 탭의 서비스워커 프로세스를 죽인 뒤가 그렇다. 그러면 `.catch` 가 걸리지 않아
 * 이 호출 뒤에 오는 코드가 통째로 실행되지 않는다.
 *
 * 실패를 예외로 올리지 않는 것도 계약의 일부다. 유일한 호출부인 배포 배너에서 해제는 되면
 * 좋은 것이고(precache 가 옛 셸을 서빙해 생기던 새로고침 루프 차단용) 목적은 리로드라,
 * 호출부는 결과를 보지 않고 늘 다음 단계로 간다.
 */
export function unregisterServiceWorkers(
  timeoutMs: number = SERVICE_WORKER_UNREGISTER_TIMEOUT_MS
): Promise<void> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.resolve();
  }

  return new Promise((resolve) => {
    const timer = setTimeout(() => resolve(), timeoutMs);
    const settle = () => {
      clearTimeout(timer);
      resolve();
    };

    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) => Promise.all(registrations.map((r) => r.unregister())))
      .then(settle, settle);
  });
}
